import { Component } from "react";
import { Badge, Button, Col, Container, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Laoding from "../../../../components/Loading";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import PaginateCard from "../../../../components/PaginateCard";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import { getRequestByAuth } from "../../../../function/helper";
import ReadTicketButton from "./components/ticket/ReadTicketButton";

export default class MessagesTablePage extends Component {
  state = {
    users: [],
    showNumber: 10,
    pageNumber: 1,
    count: 0,
    searchText: "",
    startNumber: 0,
    showModalDetail: false,
    detailTicket: {},
    loading: false,
  };

  async getData() {
    this.setState({ loading: true });
    const datas = await getRequestByAuth("/setting/v1/ticket/all", {
      numberpage: this.state.pageNumber || 1,
      numberitems: this.state.showNumber || 10,
      search: this.state.searchText || undefined,
    });
    this.setState({ loading: false });

    if (datas && datas.status === 200) {
      this.setState({
        users: datas.data.all,
        count: datas.data.count,
        startNumber: (this.state.pageNumber - 1) * this.state.showNumber + 1,
      });
    }
  }

  componentDidMount() {
    this.getData();
  }

  showDetailInModal(index) {
    this.setState({ showModalDetail: true });
    this.setState({ detailTicket: this.state.users[index].item });
  }

  onRead(ticketId) {
    const users = this.state.users.map(user => {
      if (user.item.id === ticketId) {
        user.item.isReadAnswer = 1;
      }

      return user;
    });

    this.setState({ users });
  }

  render() {
    const table = (
      <div className="w-100 px-1 overflow-x-auto">
        <Table striped bordered={true} className="w-100">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره تیکت</th>
              <th>شماره سفارش</th>
              <th>موضوع پیام</th>
              <th>وضعیت</th>
              <th>پاسخ توسط:</th>
              <th>جزییات</th>
              <th>تاریخ ثبت</th>
            </tr>
          </thead>
          <tbody>
            {this.state.loading && (
              <tr>
                <td colSpan="40">
                  <Laoding />
                </td>
              </tr>
            )}

            {!this.state.loading &&
              this.state.users.map((user, index) => (
                <tr key={index}>
                  <td>{index + this.state.startNumber}</td>
                  <td>{user.item.id}</td>
                  <td>
                    <PrintLink byNumberParcel ids={[user.item.numberParcel]}>
                      {user.item.numberParcel}
                    </PrintLink>
                  </td>
                  <td>{user.item.subject}</td>
                  <td>
                    <Badge
                      className={
                        user.item.status === "پاسخ داده شده"
                          ? "bg-primary"
                          : "bg-warning"
                      }
                    >
                      {user.item.status}
                    </Badge>
                  </td>
                  <td>
                    {user.item.admin && (
                      <p>
                        <span>(آقا/خانم) </span>
                        <span>{user.item.admin.family}</span>
                      </p>
                    )}
                  </td>
                  <td title="مشاهده جزئیات تیکت">
                    <ReadTicketButton
                      isReadAnswer={user.item.isReadAnswer}
                      ticketId={user.item.id}
                      onRead={() => {
                        this.onRead(user.item.id);
                      }}
                      onClick={() => {
                        this.showDetailInModal(index);
                      }}
                    />
                  </td>
                  <td>
                    {user.date} - {user.time}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );

    const optionArea = (
      <div className="d-flex flex-wrap row-gap-2 pt-3 pb-5">
        <Col xs={12} sm={6} lg={4} xl={3}>
          <Form.Label>تعداد نمایش:</Form.Label>
          <Form.Select
            id="disabledSelect"
            onChange={e => this.setState({ showNumber: e.target.value })}
          >
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </Form.Select>
        </Col>

        <div className="w-100">
          <Col xs={12} sm={10} lg={8}>
            <Form.Label>جستجو</Form.Label>
            <Form.Control
              placeholder="جستجو شماره سفارش، موضوع، شرح و ..."
              value={this.state.searchText}
              onChange={e => this.setState({ searchText: e.target.value })}
            />
          </Col>
        </div>

        <div>
          <LoadingButton
            isLoading={this.state.loading}
            title={this.state.loading ? "در حال دریافت" : "اعمال فیلتر"}
            className="btn-primary"
            center
            onClick={() => this.setState({ pageNumber: 1 }, this.getData)}
          />
        </div>
      </div>
    );

    return (
      <Container>
        <h4 className="text-secondary">لیست تیکت ها</h4>
        <hr />

        <div className="tableOption w-100">
          {optionArea}

          {table}

          <PaginateCard
            count={this.state.count}
            numberItems={this.state.showNumber}
            numberPage={this.state.pageNumber}
            onIndexChoose={page =>
              this.setState({ pageNumber: page }, this.getData)
            }
          />
        </div>

        <Modal
          show={this.state.showModalDetail}
          direction="rtl"
          size="xl"
          onHide={() => this.setState({ showModalDetail: false })}
          centered
          className="modal-bootstrap"
        >
          <Modal.Header>
            <h4 className="rtl">جزئیات تیکت</h4>
          </Modal.Header>
          <Modal.Body
            className=""
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <p className="m-0">
              <strong>موضوع تیکت:</strong>
              <span> {this.state.detailTicket.subject}</span>
            </p>

            <p className="m-0">
              <strong>وضعیت پیام:</strong>
              <span> {this.state.detailTicket.status}</span>
            </p>

            <p className="m-0">
              <strong>بخش مربوطه:</strong>
              <span>{this.state.detailTicket.Handlingunit}</span>
            </p>

            <p className="m-0">
              <strong>درجه اهمیت:</strong>
              <span>{this.state.detailTicket.importance}</span>
            </p>

            <p className="m-0">
              <strong>تیکت برای:</strong>
              <span>{this.state.detailTicket.typeTicket}</span>
            </p>

            <p className="m-0">
              <strong>شماره بارنامه:</strong>
              <span>{this.state.detailTicket.numberParcel}</span>
            </p>

            <p className="m-0">
              <strong>شرح:</strong>
              <span style={{ whiteSpace: "pre-line" }}>
                {this.state.detailTicket.message}
              </span>
            </p>

            <hr />

            <p className="m-0">
              <strong className="d-block">پاسخ:</strong>
              <strong style={{ whiteSpace: "pre-line" }}>
                {this.state.detailTicket.answer
                  ? this.state.detailTicket.answer
                  : "پیام شما هنوز پاسخ داده نشده است."}
              </strong>
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex align-item-center justify-content-center">
            <Button
              className="btn-cancel-style"
              onClick={() => this.setState({ showModalDetail: false })}
            >
              فهمیدم
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}
